var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"svg-icon",attrs:{"height":_vm.height,"width":_vm.width,"fill":_vm.color ? _vm.color : '#000'}},[_c('use',{attrs:{"href":'#icon-' + _vm.variant}})])}
var staticRenderFns = []

export { render, staticRenderFns }